import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';

import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';
import { TooltipInReportComponent } from '../tooltip-in-report/tooltip-in-report.component';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { FieldSequentialHeaderComponent } from '../field-sequential-header/field-sequential-header.component';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';

@Component({
    selector: 'field-type-bool',
    templateUrl: './field-type-bool.component.html',
    standalone: true,
    imports: [NgClass, TooltipInfoComponent, TooltipLawComponent, TooltipModule, AfTranslateDirective, AfTranslatePipe, TooltipInReportComponent, FieldSequentialHeaderComponent]
})

export class FieldTypeBoolComponent implements OnChanges {
  isLanding: boolean = this.customLanding.isLanding();
  fieldTypeBool: any ={
    titleField: '',
    id: this.commonUtilsService.createId(),
    bool: true,
    preSelectItem:'',
    field:null
  }

  constructor(private commonUtilsService: CommonUtilsService,
    private customLanding: CustomLandingFactory) {}

  @Input() preSelectItem:any = '';
  @Input() field:any = null;
  @Output() itemSelected = new EventEmitter();
  @Output() openRelatedInfo = new EventEmitter();

  ngOnChanges(): void {
    let that: any = this.fieldTypeBool;
    let field: any = this.field;
    if(field) {
      that.titleField = field.extendedLabel && field.extendedLabel !== ''? field.extendedLabel : field.label;
      if(field.fieldId){
        that.id = field.fieldId;
      }

      if(field.inReport !== null && field.inReport !== undefined){
        this.fieldTypeBool.inReport = field.inReport.indexOf('|') === -1? [field.inReport] : field.inReport.split('|');
      }

      that.field = this.field;
    }
    that.preSelectItem = this.preSelectItem;
  }

  selectOption(option: any){
    if(!this.field.noEditable){
      this.fieldTypeBool.preSelectItem = option === this.fieldTypeBool.preSelectItem? null : option;
      if(this.fieldTypeBool.preSelectItem === true || this.fieldTypeBool.preSelectItem === false){
        this.field.error = false;
      }
      this.itemSelected.emit({newValue:this.fieldTypeBool.preSelectItem});
    }
  }

  openModalRelatedInfo(fieldRelatedInfo:any, e:any){
    e.stopPropagation();
    e.preventDefault();
    this.openRelatedInfo.emit({relatedInfo:fieldRelatedInfo});
  }

}
